export const downloadPDF = (pdfUrl, fileName = 'document.pdf') => {
  fetch(pdfUrl)
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    })
    .catch(error => console.error('Error downloading the PDF:', error))
    .finally(() => {
      setTimeout(() => {
        document.activeElement.blur();
      }, [200]);
    });
};
